module.exports = __webpack_public_path__ + "media/images/area/feature/banner/en/pc/en_kyushu-2d3d1c3a9d611486a9bd8c6547d408de.png";